import React from 'react';

const CurrencySelector = ({ 
  currencies, 
  selectedCurrency, 
  onSelect, 
  isMobile = false 
}) => {
  if (isMobile) {
    return (
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '6px' }}>
        {currencies.map((curr) => (
          <button
            key={curr.value}
            onClick={() => onSelect(curr.value)}
            style={{
              padding: '10px 6px',
              backgroundColor: selectedCurrency === curr.value ? '#f0b90b' : '#1e2329',
              color: selectedCurrency === curr.value ? '#000' : '#eaecef',
              border: `1px solid ${selectedCurrency === curr.value ? '#f0b90b' : '#2b3139'}`,
              borderRadius: '8px',
              fontSize: '12px',
              fontWeight: '600',
              cursor: 'pointer',
            }}
          >
            <div>{curr.label}</div>
            <div style={{ fontSize: '9px', opacity: 0.7, marginTop: '2px' }}>{curr.chain}</div>
          </button>
        ))}
      </div>
    );
  }

  // Desktop version
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '12px' }}>
      {currencies.map((curr) => (
        <button
          key={curr.value}
          onClick={() => onSelect(curr.value)}
          style={{
            padding: '16px',
            backgroundColor: selectedCurrency === curr.value ? '#f0b90b' : '#181a20',
            color: selectedCurrency === curr.value ? '#000' : '#eaecef',
            border: `1px solid ${selectedCurrency === curr.value ? '#f0b90b' : '#2b3139'}`,
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer',
            textAlign: 'center',
          }}
        >
          <div>{curr.label}</div>
          <div style={{ fontSize: '11px', opacity: 0.7, marginTop: '4px' }}>{curr.chain}</div>
        </button>
      ))}
    </div>
  );
};

export default CurrencySelector;
